<!-- Header fixed at top of screen at all times -->
@if (init) {
  <app-header></app-header>
  <app-toast></app-toast>

  <!-- Main container, fills view height and width with scroll overflow -->
  <div class="header-space container-fluid overflow-hidden px-0">
    <router-outlet></router-outlet>
  </div>
}